import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default theme => {
  return {
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      '& [class*="inputWrapper"]': {
        padding: 0
      }
    },
    searchBar: {
      marginBottom: 8
    },
    gridWrapper: {
      position: 'relative',
      '& > div': _objectSpread({
        overflow: 'auto'
      }, theme.utils.scrollbar)
    },
    popover: {
      '& .hoi-poi-popover-inner': {
        backgroundColor: theme.colors.primary.white,
        boxShadow: theme.effects.boxShadow,
        borderRadius: 8,
        padding: 16
      }
    },
    emojiGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(9, 36px)'
    },
    emojiItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 6,
      borderRadius: 4,
      fontSize: 20,
      lineHeight: 1,
      cursor: 'pointer',
      boxSizing: 'border-box',
      '& img': {
        display: 'block',
        width: 'auto',
        height: 20
      }
    },
    emojiItemActive: {
      backgroundColor: theme.colors.semantic.infoCustom50,
      boxShadow: `inset 0 0 1px 1px ${theme.colors.semantic.info150}`
    },
    emojiItemHover: {
      backgroundColor: theme.colors.semantic.infoCustom50
    },
    section: {
      textTransform: 'capitalize',
      padding: '8px 0',
      gridColumn: '1 / span 9',
      whiteSpace: 'nowrap'
    },
    sectionSticky: {
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      width: 'calc(100% - 12px)',
      // 100% - the scrollbar track width
      backgroundColor: theme.colors.primary.white
    },
    hint: {
      boxSizing: 'border-box',
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap: 8,
      height: 45,
      padding: '12px 16px 0',
      margin: '0 -16px -4px',
      borderTop: `1px solid ${theme.colors.grey[100]}`
    },
    hintIcon: {
      fontSize: 32,
      lineHeight: 1,
      '& img': {
        display: 'block',
        width: 'auto',
        height: 32
      }
    },
    empty: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 176,
      width: 336
    }
  };
};